(function () {
  if (window.__pdConsent) return;

  var initRan = false; // Prevent multiple initAll() calls

  function onPrivacyReady(cb) {
    if (window.Shopify && Shopify.customerPrivacy) return cb();
    var tries = 0,
      t = setInterval(function () {
        if (++tries > 40) return clearInterval(t);
        if (window.Shopify && Shopify.customerPrivacy) {
          clearInterval(t);
          cb();
        }
      }, 100);
  }

  function attemptInit() {
    if (
      !(
        window.Shopify &&
        Shopify.customerPrivacy &&
        Shopify.customerPrivacy.userCanBeTracked
      )
    ) {
      return;
    }

    try {
      var result = Shopify.customerPrivacy.userCanBeTracked();
      if (result && typeof result.then === "function") {
        result
          .then(function (canTrack) {
            if (canTrack) {
              window.__pdConsent.initAll();
            }
          })
          .catch(function () {});
      } else if (result === true) {
        window.__pdConsent.initAll();
      }
    } catch (error) {
      try {
        console.warn("[consent-gates] Failed to check consent state", error);
      } catch (e) {}
    }
  }

  function wrapSetTrackingConsent() {
    if (!(window.Shopify && Shopify.customerPrivacy)) return;
    var originalSet = Shopify.customerPrivacy.setTrackingConsent;
    if (typeof originalSet !== "function" || originalSet.__pdWrapped) return;

    var wrapped = function () {
      var result = originalSet.apply(this, arguments);
      var onSettled = function () {
        attemptInit();
      };

      try {
        if (result && typeof result.then === "function") {
          result.then(onSettled).catch(function () {
            attemptInit();
          });
        } else {
          setTimeout(attemptInit, 0);
        }
      } catch (error) {
        setTimeout(attemptInit, 0);
      }

      return result;
    };

    wrapped.__pdWrapped = true;
    Shopify.customerPrivacy.setTrackingConsent = wrapped;
  }

  function ensureFbqStub() {
    if (window.fbq) return;

    var fbq = function () {
      fbq.callMethod
        ? fbq.callMethod.apply(fbq, arguments)
        : fbq.queue.push(arguments);
    };

    fbq.queue = [];
    fbq.loaded = false;
    fbq.version = "2.0";
    fbq.push = fbq;
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
  }

  window.__pdConsent = {
    initAll: function () {
      if (initRan) return; // Prevent multiple calls
      initRan = true;

      // Call whichever loaders you need:
      // this.loadHotjar(); // Removed for performance optimization

      this.activateMetaPixel();
      this.activateKlaviyo();
      this.activateTrustpilot();
    },
    
    activateKlaviyo: function() {
        if (typeof this.loadKlaviyoScript === 'function') {
            this.loadKlaviyoScript().catch(function(e){ console.warn("Klaviyo failed to load:", e); });
        }
    },

    activateTrustpilot: function() {
        if (typeof this.loadTrustpilotScript === 'function') {
            this.loadTrustpilotScript().catch(function(e){ console.warn("Trustpilot failed to load:", e); });
        }
    },
    loadHotjar: function () {
      if (window.hj) return;
      (function (h, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
        h._hjSettings = { hjid: 2778074, hjsv: 6 };
        a = o.getElementsByTagName("head")[0];
        r = o.createElement("script");
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

      // Hotjar customer identification - will be set by liquid template if customer exists
      if (window.hjCustomerData) {
        window.hj(
          "identify",
          window.hjCustomerData.id,
          window.hjCustomerData.attributes
        );
      }
    },

    activateMetaPixel: function () {
      // Get pixel ID from theme settings
      var pixelId =
        window.theme &&
        window.theme.settings &&
        window.theme.settings.metaPixelId;
      if (!pixelId) {
        console.warn("[consent-gates] No Meta Pixel ID configured");
        return;
      }

      ensureFbqStub();

      // Check if script is already loaded
      var existingScript = document.querySelector('script[src*="fbevents.js"]');
      if (existingScript) {
        console.log(
          "[consent-gates] Facebook Pixel script already loaded, initializing..."
        );
        ensureFbqStub();
        if (window.fbq && window.fbq.callMethod) {
          window.fbq("init", pixelId);
          window.fbq("track", "PageView");
        } else {
          existingScript.addEventListener("load", function () {
            if (window.fbq) {
              window.fbq("init", pixelId);
              window.fbq("track", "PageView");
            }
          });
        }
        return;
      }

      // Load the pixel script via the error handler helper
      var scriptLoader =
        window.__pdConsent && window.__pdConsent.loadMetaPixelScript;
      if (typeof scriptLoader === "function") {
        scriptLoader()
          .then(function () {
            // Wait for script to load, then initialize
            ensureFbqStub();
            if (window.fbq) {
              window.fbq("init", pixelId);
              window.fbq("track", "PageView");
            }
          })
          .catch(function (error) {
            console.error(
              "[consent-gates] Failed to load Facebook Pixel:",
              error
            );
          });
      } else {
        // Fallback: load directly
        ensureFbqStub();
        var script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";
        script.onload = function () {
          if (window.fbq) {
            window.fbq("init", pixelId);
            window.fbq("track", "PageView");
          }
        };
        script.onerror = function (error) {
          console.error(
            "[consent-gates] Failed to load Facebook Pixel:",
            error
          );
        };
        document.head.appendChild(script);
      }
    },
  };

  // Fire when accepted on this page:
  document.addEventListener("trackingConsentAccepted", attemptInit);

  // Fire immediately on pages where consent was already granted (with privacy API backstop):
  onPrivacyReady(function () {
    attemptInit();
    wrapSetTrackingConsent();
  });

  // Also listen for privacy API changes
  onPrivacyReady(function () {
    if (
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.on === "function"
    ) {
      Shopify.customerPrivacy.on("change", attemptInit);
    }
  });
})();
